var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('v-subheader',[_c('h1',{staticClass:"accent--text"},[_vm._v("Storico magazzino")])]),(_vm.materials)?_c('div',[_c('v-container',[_c('v-row',[_c('v-col',[_c('v-data-table',{staticClass:"elevation-5",attrs:{"headers":_vm.headers,"items":_vm.materials,"items-per-page":20}})],1)],1)],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }